export enum PageStatus {
  INITIAL,
  SUCCESS,
  ERROR,
}
